module.exports = __webpack_public_path__ + "static/media/travisgo_tablet_bg_businesspartner@1x.772fe015.jpg";